var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrincipal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "62px",
    height: "62px",
    viewBox: "0 0 62 62",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon/overview/principal") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "path-1",
    cx: 30,
    cy: 30,
    r: 30
  }), /*#__PURE__*/React.createElement("circle", {
    id: "path-3",
    cx: 30,
    cy: 30,
    r: 30
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "States-&-Styles-&-Assets",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Assets---Icons",
    transform: "translate(-175.000000, -246.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon/overview/principal",
    transform: "translate(176.000000, 247.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-11"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Mask"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Oval",
    stroke: "#444B68",
    strokeWidth: 2,
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "card-icon/principal",
    transform: "translate(11.000000, 13.000000)",
    fill: "#444B68",
    stroke: "#444B68",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Star",
    strokeWidth: 2.4,
    points: "19 25.84 7.83208021 34.3713229 12.4947734 21.1136762 0.92992619 13.1286771 14.9795489 13.4663238 19 0 23.0204511 13.4663238 37.0700738 13.1286771 25.5052266 21.1136762 30.1679198 34.3713229"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrincipal);
export default __webpack_public_path__ + "static/media/principal.e6a1a6e16ae40a578b69a10d95c8e0b9.svg";
export { ForwardRef as ReactComponent };